import { configureStore } from "@reduxjs/toolkit";

import uiSlice from "./ui-slice";
import authSlice from "./auth-slice";
import userSlice from "./user-slice";
import jobstatusSlice from "./jobstatus-slice";
import incomingInventorySlice from "./incominginventory-slice";
import forecastReportTypeSlice from "./forecastReportTypeSlice";
import forecastSlice from "./forecast-slice";
import reviewSlice from "./review-slice";
import adminSlice from "./adminSlice";
const store = configureStore({
  reducer: {
    ui: uiSlice.reducer,
    auth: authSlice.reducer,
    user: userSlice.reducer,
    jobstatus: jobstatusSlice.reducer,
    incominginventory: incomingInventorySlice.reducer,
    forecastReportType: forecastReportTypeSlice.reducer,
    forecast: forecastSlice.reducer,
    review: reviewSlice.reducer,
    admin: adminSlice,
  },
});

export default store;
